module.exports = __webpack_public_path__ + "img/image_2024_11_04T08_31_33_904Z.958833c4.png";